import React from "react";
import { FiChevronRight, FiMapPin, FiClock, FiAlertTriangle, FiLogOut } from 'react-icons/fi';
import { IoMdCar } from 'react-icons/io';
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IIssueAtLocationOutput } from "../../../../logic/api";
import { useDate } from "../../../../utility/useDate";
import { getStatusLabel, getStatusColor, getIssueTypeLabel } from "./issueUtils";
import vehicleIssueStyles from "./styles"

import ListViewItemCard from "../../../../components/cards/ListItemCard/ListItemCard";

interface IssueListItemProps {
  issue: IIssueAtLocationOutput;
  onClick: () => void;
}

const IssueListItem: React.FunctionComponent<IssueListItemProps> = ({ issue, onClick }) => {
  const { issueListItem } = vehicleIssueStyles;

  const { t } = useTranslation();
  const { toFormattedDateString, toFormattedTimeString } = useDate();

  const statusColor = getStatusColor(issue.status);
  const statusLabel = getStatusLabel(issue.status, t);
  const issueTypeLabel = getIssueTypeLabel(issue.issue, t);

  return (
    <Box
      data-testid={`issue-item-${issue.id}`}
      sx={{
        ...issueListItem.itemContainer,
        borderColor: `${statusColor}`,
        borderLeftColor: `${statusColor}`,
      }}
      onClick={onClick}
    >
      <Box
        sx={issueListItem.statusBox}
      >
        {statusLabel}
      </Box>

      <Box
        sx={issueListItem.listViewBox}
      >
        <ListViewItemCard
          icon={<FiAlertTriangle style={issueListItem.itemCardIcon} />}
          text={issueTypeLabel}
          subText={issue.issueType}
        />

        <ListViewItemCard
          icon={<FiMapPin style={issueListItem.itemCardIcon} />}
          text={issue.locationParentName}
          subText={issue.locationName}
        />

        <ListViewItemCard
          icon={<IoMdCar style={issueListItem.itemCardIcon} />}
          text={issue.vehicleReg}
          subText={`${issue.vehicleMake} ${issue.vehicleModel}`}
          subSubText={issue.vehicleColor}
        />

        <ListViewItemCard
          icon={<FiClock style={issueListItem.itemCardIcon} />}
          text={t("locations.vehicleIssues.fields.recordedAt")}
          subText={toFormattedDateString(new Date(issue.recordedAt))}
          subSubText={toFormattedTimeString(new Date(issue.recordedAt))}
        />

        {issue.expectedReturnTime && (
          <ListViewItemCard
            icon={<FiLogOut style={issueListItem.itemCardIcon} />}
            text={toFormattedDateString(new Date(issue.expectedReturnTime))}
            subText={toFormattedTimeString(new Date(issue.expectedReturnTime))}
          />
        )}

        <Box sx={{ flexGrow: 1 }}>
          <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", height: "100%" }}>
            <Box sx={{ color: "black", flexGrow: 1 }}>
              <FiChevronRight style={{ fontSize: 24, marginLeft: 20, marginRight: 10 }} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default IssueListItem;